<script>
export default {
  name: "Banner",
  props:{
    bannerList:Array
  },
  data(){
    return {
      swiperOptions:{
        slidesPerView: 1,
        // spaceBetween: 30,
        loop: this.bannerList.length > 1 ? true :false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoplay: this.bannerList.length > 1
          ? { delay: 3000 }
          : false
      },
    }
  }
}
</script>

<template>
  <div class="banner-box common-box">
    <div class="swiper-container">
      <swiper
        ref="mySwiper"
        :options="swiperOptions"
      >
        <swiper-slide
          v-for="(item, index) in bannerList"
          :key="index"
        >
          <img
            :src="item"
            class="slide-image"
            alt="轮播图"
          />
        </swiper-slide>
        <div
          slot="pagination"
          class="swiper-pagination"
        ></div>
        <div
          v-if="bannerList.length>1"
          slot="button-prev"
          class="swiper-button-prev"
        ></div>
        <div
          v-if="bannerList.length>1"
          slot="button-next"
          class="swiper-button-next"
        ></div>
      </swiper>
    </div>
  </div>
</template>

<style scoped lang="less">
.banner-box{
  img{
    width: 100%;
    display: block;
  }
}
/deep/ .swiper-button-prev, .swiper-button-next{
  color: rgba(85, 19, 29, 0.2);
}
/deep/ .swiper-pagination-bullet-active{
  background-color: rgba(85, 19, 29, 1);
}
</style>
